import type { ProgramTerms } from '../shared';

export const emgalityTerms: ProgramTerms = {
    'self-pay': null,
    insurance: null,
};
